import Footer from '../../components/Footer'

import Header from './Header'
import Home from './Home'

const HomePage = () => {
  return (
    <>
      <Header />
      <Home />
      <Footer />
    </>
  )
}

export default HomePage
